import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [],
  templateUrl: './status-badge.component.html',
  styleUrl: './status-badge.component.scss'
})
export class StatusBadgeComponent implements ICellRendererAngularComp {

  params: any;
  value: string = '';
  badgeClass: string = '';
  // Set when the badge should show a leading coloured dot (variant-keyed badges).
  showDot: boolean = false;

  agInit(params: any): void {
    this.render(params);
  }

  // Resolves label + badgeClass from either a { label, variant } object value
  // or a plain status string. Object form keys off `variant` and shows a dot.
  private render(params: any): void {
    this.params = params;
    const raw = params.value;

    // Variant object value: { label, variant } (e.g. Data Fidelity badges).
    if (raw && typeof raw === 'object' && 'variant' in raw) {
      this.value = raw.label ?? '';
      this.badgeClass = this.classForVariant(raw.variant);
      this.showDot = true;
      return;
    }

    // Plain status string.
    this.value = params.valueFormatted || raw || '';
    this.badgeClass = this.classForStatus(this.value);
    this.showDot = false;
  }

  private classForVariant(variant: string): string {
    switch (variant) {
      case 'factual':
        return 'ag-grid-pill-success';
      case 'hybrid':
        return 'ag-grid-pill-warning';
      case 'modeled':
        return 'ag-grid-pill-secondary';
      default:
        return 'ag-grid-pill-secondary';
    }
  }

  private classForStatus(value: string): string {
    switch (value) {
      case 'Booked':
      case 'booked':
        return 'ag-grid-pill-info';
      case 'Delivered':
      case 'customer_delivered':
        return 'ag-grid-pill-warning';
      case 'Provider Delivered':
      case 'provider_delivered':
      case 'In Transit':
      case 'provider_collected':
        return 'ag-grid-pill-success';
      default:
        return 'ag-grid-pill-secondary';
    }
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.render(params);
    return true;
  }
}
